import { FiSnackbarComponent } from './fi-snackbar.component';
import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

export interface IFiSnackbarData {
    textMessage: string;
    iconClass?: string;
    buttonText?: string;
    buttonClass?: string;
    buttonIconClass?: string;
    durationMs?: number;
    isSnackbarBorderShown?: boolean;
    preventButtonUppercase?: boolean;
    colorClass?: 'branded' | 'red' | 'blue';
}

@Injectable()
export class FiSnackBarService {
    constructor(private matSnackBar: MatSnackBar) {}

    showSnackbar(data: IFiSnackbarData, isBranded = true, panelClass?: string) {
        const snackbarPanelClasses: string[] = isBranded ? ['BrandedBackgroundColor'] : [];
        if (panelClass) {
            snackbarPanelClasses.push(...panelClass.split(' '));
        }
        if (data.colorClass) {
            snackbarPanelClasses.push(data.colorClass);
        }
        return this.matSnackBar.openFromComponent(FiSnackbarComponent, {
            data: data,
            panelClass: snackbarPanelClasses,
            duration: data.durationMs ? data.durationMs : 4000,
        });
    }
}
